var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0558 7.49637L9.67883 4.36059L2.85341 11.68C3.14263 12.2261 3.4827 12.7144 3.87389 13.146L9.29093 7.34288C9.50803 7.11031 9.87254 7.09777 10.1051 7.31486C10.3377 7.53195 10.3502 7.89647 10.1331 8.12903L4.71866 13.9294C5.17088 14.2809 5.67307 14.5778 6.2263 14.8201L13.0558 7.49637ZM13.8415 6.65378L14.987 5.42545C15.204 5.19278 15.1912 4.82827 14.9586 4.6113L12.4308 2.25412C12.1981 2.03715 11.8336 2.04988 11.6166 2.28255L10.4646 3.518L13.8415 6.65378ZM1.72929 11.1961C1.73515 11.1896 1.74117 11.1831 1.74735 11.1768L10.774 1.49682C11.425 0.798801 12.5185 0.760614 13.2165 1.41153L15.7443 3.76871C16.4423 4.41963 16.4805 5.51316 15.8296 6.21118L6.5431 16.1697C6.35929 16.3668 6.11219 16.4932 5.84479 16.527L1.72523 17.047C1.34646 17.0948 1.00065 16.8265 0.953202 16.4506C0.946766 16.3839 0.946766 16.3839 0.948474 16.3227L1.17986 12.1769C1.19487 11.9078 1.30376 11.6525 1.48757 11.4553L1.72929 11.1961ZM2.28888 12.9807L2.12959 15.8347L4.96745 15.4765C4.4246 15.1679 3.92859 14.8044 3.48024 14.3863C3.03336 13.9696 2.63619 13.5008 2.28888 12.9807Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.04bf96f584e1a31d81b07f934aef77f5.svg";
export { ForwardRef as ReactComponent };